import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";
import { ApiEvsService } from "./ApiEvs.service";

@Injectable()
export class WarningOutdateService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }
  getListWarningOutdate() {
    return this.get("/dashboard/warning-usage-time");
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/WarningOutdate.service.ts